// extracted by mini-css-extract-plugin
module.exports = {"title":"timeout_title_2s0pG"};